import { TypeFormWithUrlParamsFields } from 'contentful-types'
import { withContentful } from 'src/siteBuilder/renderer/contentful/withContentful'
import FormWithUrlParams from './FormWithUrlParams'

const ContentfulFormWithUrlParams = withContentful<TypeFormWithUrlParamsFields>(FormWithUrlParams, {})

export default ContentfulFormWithUrlParams
